import tw, {styled} from 'twin.macro';
import { Link } from 'gatsby'
import { Container } from '../globalStyles';
import { Icon } from '../icon';

export const FooterOuter = tw.footer`w-full bg-black block pt-20 pb-30 lg:pt-40 lg:pb-80`;
export const FooterContainer = tw(Container)``
export const Row = tw.div``
export const FooterRow = tw.div`block lg:flex items-center justify-between pb-20 border-b border-white-30per mb-20 lg:pb-40 lg:mb-40 xl:pb-50 xl:mb-50`
export const FooterCopyright = tw.div`block lg:flex items-center justify-between`

export const LogoLink = tw(Link)`block text-white h-52 lg:h-70 max-w-120 cursor-pointer`;
export const Logo = tw(Icon)`h-full w-auto max-w-full`;
export const Image = tw.img`h-full w-auto max-w-full object-contain`;
export const SocialLink = tw.a`w-40 lg:w-56 mr-10 lg:ml-20 block block`
export const SocialIcon = tw(Icon)`w-40 lg:w-56 h-40 lg:h-56 block`
export const SocialGroup = tw.div`flex items-center justify-start lg:justify-end`;

export const Copyright = styled.p`
    ${tw`text-white mb-20 text-left lg:max-w-50per lg:mb-0`}
    &:last-child {
        ${tw`mb-0 whitespace-nowrap`}
    }
`;

export const MenuLinks = tw.div`w-full flex items-start justify-between lg:justify-start flex-wrap lg:flex-nowrap gap-x-20 gap-y-10 mb-20 lg:mb-0 lg:gap-x-30 mac:gap-x-50`;
export const MenuItem = tw(Link)`text-white text-16 w-47per lg:w-auto text-left hover:text-orange-dark transition-all duration-500`
export const LogoGroup = tw.div`flex flex-wrap items-center justify-start gap-20`